module.exports = __webpack_public_path__ + "static/media/sr_weiss.bbe128bd.svg";